import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { IntroService } from 'src/app/shared/services/intro.service';

@Component({
  selector: 'header-tour',
  template: `
    @if (!isMobileView) {
      <div
        *ngIf="visible"
        class="alain-default__nav-item"
        (click)="startTour()"
        nz-tooltip
        nzTooltipTitle="Play onboarding tours"
        nzTooltipPlacement="bottom"
      >
        <i nz-icon nzType="play-circle"></i>
      </div>
    } @else {
      <div
        *ngIf="visible"
        class="alain-default__nav-item"
        (click)="startTour()"
      >
        <i nz-icon nzType="play-circle"></i>
      </div>
    }
  `,
  standalone: false
})
export class HeaderTourComponent implements OnInit {
  visible = true;
  isMobileView: boolean = window.innerWidth <= 1024;

  constructor(private intro: IntroService, private router: Router) {
    this.router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) 
        this.tryGetIntroConfig();
    });

    this.tryGetIntroConfig();
  }

  tryGetIntroConfig() {
    setTimeout(() => {
      const info = this.intro.getIntroConfig();
      if (info) {
        this.visible = true;
        this.intro.playIfNew(info.key, info.data);
      } else {
        this.visible = false;
      }
    }, 1000);
  }

  startTour() {
    this.intro.replay();
  }

  ngOnInit() {
    this.detectView();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.detectView();
  }
  detectView() {
    this.isMobileView = window.innerWidth <= 1024;
  }
}
